import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  name: string;
  _type: string;
  risk_level: "low" | "medium" | "high";
  active: boolean;
  code: string;
}
export const useCreateSICIndustry = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/sic_industry_risk_level/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
